import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      accessToken
      refreshToken
      user {
        id
        email
        firstName
        lastName
        role
        schema
        onBoarding
        companyId
        homeCompanyId
        companyName
        twoFactorEnabled
        aiEnabled
      }
    }
  }
`;


// Switch Company Mutation

export const SWITCH_COMPANY_MUTATION = gql`
    mutation SwitchCompanyContext ($input: SwitchCompanyInput!) {
        switchCompanyContext(input: $input) {
            accessToken
            refreshToken
            user {
                id
                email
                firstName
                lastName
                role
                companyId
                homeCompanyId
                companyName
                schema
                subdomain
                onBoarding
                twoFactorEnabled
                invitationStatus
                invitedBy
                invitedOn
                active
                deletedAt
                aiEnabled
            }
        }
    }
`;

// Create Asset Category Mutation

export const SEND_INVITATION_MUTATION = gql`
  mutation SendInvitation($input: SendInvitationInput!) {
    sendInvitation(input: $input) {
      id
      email
      role
      status
      expiresAt
    }
  }
`;

// Update Company User Mutation (for edit)

export const ACCEPT_INVITATION_MUTATION = gql`
mutation AcceptInvitation($input: AcceptInvitationInput!) {
    acceptInvitation(input: $input) {
        accessToken
        refreshToken
        __typename
    }
  }
`;

// Resend Invitation Mutation

export const RESEND_INVITATION_MUTATION = gql`
  mutation ResendInvitation($input: ResendInvitationInput!) {
    resendInvitation(input: $input){
      id
        email
        role
        status
        expiresAt
        }
  }
`;

// Signup Mutation (creates tenant company with schema)

export const SIGNUP_MUTATION = gql`
  mutation Signup($input: SignupInput!) {
    signup(input: $input) {
      accessToken
      refreshToken
    }
  }
`;

// Forgot Password Mutation
// Request Password Reset (Forgot Password)

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation RequestPasswordReset($input: ResetPasswordRequestInput!) {
    requestPasswordReset(input: $input)
  }
`;

// Reset Password Mutation

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;

// Change Password Mutation

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`;

// Create Location Mutation
